import { DocumentFileType } from "@repo/models";

import type { Props } from "./types";

import { HTMLDocumentReview } from "./htmlDocumentReview";
import { PdfDocumentReview } from "./pdfDocumentReview";

export function DocumentReview(props: Props) {
	if (props.type === DocumentFileType.pdf) {
		return <PdfDocumentReview {...props} />;
	}
	return <HTMLDocumentReview {...props} />;
}
